import { render, staticRenderFns } from "./SVGWrapper.vue?vue&type=template&id=fc33553c&scoped=true&"
import script from "./SVGWrapper.vue?vue&type=script&lang=js&"
export * from "./SVGWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SVGWrapper.vue?vue&type=style&index=0&id=fc33553c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc33553c",
  null
  
)

export default component.exports